export const CITIES_GET_REQUESTING = 'CITIES_GET_REQUESTING';
export const CITIES_GET_SUCCESS = 'CITIES_GET_SUCCESS';
export const CITIES_GET_ERROR = 'CITIES_GET_ERROR';